module.exports = __webpack_public_path__ + "img/22.a3854773.png";